import { appConfig } from '@common/config';
import { DETAIL_STATE } from '@constants/common';
import { type IDetailIndexPorps, type IDetailItemInfo } from '@interface/IDetail';
import { itemInfoQueryKey } from '@network/queryKeys';
import { useDataQuery } from '@network/querys';
import { keepPreviousData } from '@tanstack/react-query';
import { type ReactNode } from 'react';

export const ItemIndex = ({ props, children }: { props: IDetailIndexPorps; children: ReactNode }) => {
    const { isFetching } = useDataQuery<IDetailItemInfo>(
        itemInfoQueryKey,
        `/${appConfig.service}/v2.0/game/item/${props.detailId}`,
        { level: props.detailLevel },
        {
            staleTime: 5000,
            placeholderData: keepPreviousData,
            enabled: props.detailNow === DETAIL_STATE.ITEM && !!props.detailId,
        }
    );

    if (isFetching)
        return (
            <div className="gameinfo-loader is-show">
                <span className="loader" />
            </div>
        );

    return <div className="gameinfo-detail__list">{children}</div>;
};
export default ItemIndex;
